<div class="body audit-body">

    <div *ngIf="notes" class="note-wrapper" [innerHtml]="notes"></div>

    <div *ngFor="let change of changeChains" class="section">

        <div class="attribute">{{change.attribute}}</div>
        <div class="value-row entry">

            <ng-container *ngIf="change.values.length > 0; else noValue">

                <ng-container *ngFor="let value of change.values">

                    <div class="value-wrapper">
    
                        <span *ngIf="value; else noValue">
                            {{value}}
                        </span>
            
                        <mat-icon class="arrow">arrow_left</mat-icon>
    
                    </div>
    
                </ng-container>

            </ng-container>

            <ng-template #noValue>

                <span class="no-value">Kein Wert</span>

            </ng-template>

        </div>

    </div>

    <div class="note-audit">

        <app-html-note-diff [oldNote]="initialNote$|async" [newNote]="latestNote$|async"></app-html-note-diff>

    </div>

</div>